import { Outlet, ScrollRestoration, useLocation } from "react-router";
import { useSyncPoll } from "@/lib/query/useSyncPoll";
import { useUi } from "@/lib/store/ui";
import { useSession } from "@/lib/store/session";
import { cn } from "@/lib/utils/cn";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BottomTabBar } from "./BottomTabBar";
import { Sidebar, SIDEBAR_RAIL_WIDTH, SIDEBAR_WIDTH } from "./Sidebar";
import { SyncBanner } from "./SyncBanner";
import { TopBar } from "./TopBar";
import { AddEmailDialogHost } from "@/features/auth/AddEmailDialogHost";

export function AppShell() {
  useSyncPoll();
  const collapsed = useUi((s) => s.sidebarCollapsed);
  const loggedIn = useSession((s) => !!s.userId);
  const { pathname } = useLocation();

  return (
    <TooltipProvider delayDuration={300}>
      <div className="min-h-dvh bg-bg">
        <Sidebar />
        <div
          className="flex min-h-dvh flex-col transition-[padding] duration-200 tab:pl-[var(--sidebar-w)]"
          style={{ "--sidebar-w": `${collapsed ? SIDEBAR_RAIL_WIDTH : SIDEBAR_WIDTH}px` } as React.CSSProperties}
        >
          <TopBar />
          <SyncBanner />
          <main
            id="main"
            className={cn("flex-1", loggedIn ? "pb-[calc(3.5rem+var(--spacing-safe-bottom))] tab:pb-0" : "pb-safe-bottom")}
          >
            <ErrorBoundary key={pathname}>
              <Outlet />
            </ErrorBoundary>
          </main>
        </div>
        {/* Scrolls to the top on a new history entry and restores the saved offset on
            back. Keyed on location.key, the same key ActivityList reveals its paging
            window under, so the two agree on what "this entry" means. */}
        <ScrollRestoration />
        <BottomTabBar />
        <AddEmailDialogHost />
      </div>
    </TooltipProvider>
  );
}
